import { useEffect } from 'react';

export const useSwipeNavigation = () => {
  useEffect(() => {
    // Проверяем PWA режим
    const isPWA = window.matchMedia('(display-mode: standalone)').matches;
    
    // Проверяем мобильное устройство
    const isMobile = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    
    if (!isPWA || !isMobile) {
      return; // Выходим, если не PWA или не мобильное устройство
    }

    let touchStartX = 0;
    let touchStartY = 0;
    let touchStartTime = 0;
    const minSwipeDistance = 100; // 100px
    const maxSwipeTime = 500; // 500ms

    const handleTouchStart = (e: TouchEvent) => {
      // Проверяем, что не в чате или модальном окне
      if (isInChatOrModal()) {
        return;
      }

      const touch = e.touches[0];
      touchStartX = touch.clientX;
      touchStartY = touch.clientY;
      touchStartTime = Date.now();
    };

    const handleTouchEnd = (e: TouchEvent) => {
      // Проверяем, что не в чате или модальном окне
      if (isInChatOrModal()) {
        return;
      }

      const touch = e.changedTouches[0];
      const touchEndX = touch.clientX;
      const touchEndY = touch.clientY;
      const touchEndTime = Date.now();

      const deltaX = touchEndX - touchStartX;
      const deltaY = touchEndY - touchStartY;
      const deltaTime = touchEndTime - touchStartTime;

      // Проверяем, что это горизонтальный свайп (не вертикальный скролл)
      if (Math.abs(deltaX) < Math.abs(deltaY)) {
        return;
      }

      // Проверяем время и расстояние
      if (deltaTime > maxSwipeTime || Math.abs(deltaX) < minSwipeDistance) {
        return;
      }

      // Определяем направление свайпа
      if (deltaX > 0) {
        // Свайп вправо - назад
        window.history.back();
      } else {
        // Свайп влево - вперед
        window.history.forward();
      }
    };

    const isInChatOrModal = (): boolean => {
      // Проверяем, что не в чате (UserPage с активным чатом)
      const chatContainer = document.querySelector('.chat-container') as HTMLElement;
      if (chatContainer && chatContainer.style.display !== 'none') {
        return true;
      }

      // Проверяем, что не в модальном окне
      const modals = document.querySelectorAll('.modal, [role="dialog"], .fixed.inset-0');
      for (let i = 0; i < modals.length; i++) {
        const modal = modals[i] as HTMLElement;
        if (modal && modal.style.display !== 'none' && !modal.classList.contains('hidden')) {
          return true;
        }
      }

      return false;
    };

    // Добавляем обработчики событий
    document.addEventListener('touchstart', handleTouchStart, { passive: true });
    document.addEventListener('touchend', handleTouchEnd, { passive: true });

    // Очистка при размонтировании
    return () => {
      document.removeEventListener('touchstart', handleTouchStart);
      document.removeEventListener('touchend', handleTouchEnd);
    };
  }, []);
};
